var m = require('mithril');
var heading = require('../../components/heading');
var button = require('../../components/button');
var modalForm = require('../../layout/components/modalForm');
var loaders = require('../../layout/components/loaders');
var fieldnetTree = require('../../network/components/fieldnetTree');
var variableBase = require('../../data/models/variable');
var Report = require('../../../../../models/reports/report');

var component = {};
var pointResources = {};
var pointResourcesLoading = {};

var auxiliaryPointVariable = Object.create(variableBase);
auxiliaryPointVariable.fields = Object.assign({}, variableBase.fields);
auxiliaryPointVariable.fields.name = Object.assign({}, variableBase.fields.name, {default: 'Report Point'});
auxiliaryPointVariable.initForm = function (record, options) {
  variableBase.initForm.call(this, record, options);
  if (this.form.in && this.form.in() && typeof this.form.in() === 'object' && this.form.in()['@rid']) {
    this.form.in(this.form.in()['@rid']);
  }
};
auxiliaryPointVariable.view = function () {
  return m('form', {role:'form'}, [
    auxiliaryPointVariable.errorView(),
    m(fieldnetTree, {selectedPoint: auxiliaryPointVariable.form.in})
  ]);
};
var auxiliaryPointForm = modalForm(auxiliaryPointVariable);

function normalizeRid(rid) {
  var normalized = rid;
  if (normalized && typeof normalized === 'object' && normalized['@rid']) {
    normalized = normalized['@rid'];
  }
  if (typeof normalized === 'string' && normalized.charAt(0) !== '#') {
    normalized = '#' + normalized;
  }
  return normalized;
}

function getReportTypeMeta(record) {
  var type = record && record.type ? record.type : 'Custom Export';
  return Report.getTypeMeta ? Report.getTypeMeta(type) : {};
}

function getAuxiliaryPointsConfig(record) {
  var meta = getReportTypeMeta(record);
  var ui = meta && meta.ui ? meta.ui : {};
  return ui && ui.auxiliaryPoints ? ui.auxiliaryPoints : {};
}

function normalizeVariableEdge(edge, reportRid) {
  if (!edge) {
    return null;
  }
  if (typeof edge === 'string') {
    return {'@rid': edge, out: reportRid};
  }
  if (edge.in && typeof edge.in === 'object' && edge.in['@rid']) {
    edge.in = edge.in['@rid'];
  }
  if (edge.out && typeof edge.out === 'object' && edge.out['@rid']) {
    edge.out = edge.out['@rid'];
  }
  if (!edge.out && reportRid) {
    edge.out = reportRid;
  }
  return edge;
}

function getVariablePointRid(edge) {
  if (!edge || !edge.in) return null;
  if (typeof edge.in === 'string') return edge.in;
  return edge.in['@rid'] || null;
}

function getMatchingVariableEdges(record, pointConfig) {
  var reportRid = record && record['@rid'];
  var normalizedEdges = (Array.isArray(record && record.out_Variable) ? record.out_Variable : [])
    .map(function (edge) {
      return normalizeVariableEdge(edge, reportRid);
    })
    .filter(Boolean);
  var pointIndex = Number(pointConfig && pointConfig.index);
  var matchesByIndex = Number.isFinite(pointIndex)
    ? normalizedEdges.filter(function (edge) {
        return Number(edge && edge.index) === pointIndex;
      })
    : [];

  if (matchesByIndex.length > 0) {
    return matchesByIndex;
  }

  var pointName = String(pointConfig && pointConfig.name || '').trim().toLowerCase();
  if (!pointName) {
    return [];
  }

  return normalizedEdges.filter(function (edge) {
    return String(edge && edge.name || '').trim().toLowerCase() === pointName;
  });
}

function buildNewVariableEdge(record, pointConfig) {
  return {
    out: record && record['@rid'],
    name: pointConfig && pointConfig.name ? pointConfig.name : 'Report Point',
    index: pointConfig && pointConfig.index != null ? pointConfig.index : null
  };
}

function loadPointResource(ctrl, pointRid) {
  var normalizedRid = normalizeRid(pointRid);
  if (!normalizedRid) {
    return;
  }

  if (pointResources[normalizedRid] || pointResourcesLoading[normalizedRid]) {
    return;
  }

  pointResourcesLoading[normalizedRid] = true;
  return loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/point/' + normalizedRid.slice(1) + '/resource',
    method: 'GET',
    background: true
  })
  .then(function (result) {
    pointResources[normalizedRid] = result;
  })
  .catch(function () {
    pointResources[normalizedRid] = null;
  })
  .finally(function () {
    pointResourcesLoading[normalizedRid] = false;
    m.redraw();
  });
}

function buildResourcePathLabel(ctrl, pointRid) {
  var normalizedRid = normalizeRid(pointRid);
  if (!normalizedRid) {
    return 'No path';
  }

  loadPointResource(ctrl, normalizedRid);
  var resourceRecord = pointResources[normalizedRid];
  if (!resourceRecord) {
    return pointResourcesLoading[normalizedRid] ? 'Loading path...' : normalizedRid;
  }

  var resourcePath = Array.isArray(resourceRecord.breadcrumbs)
    ? resourceRecord.breadcrumbs
    : (Array.isArray(resourceRecord.path) ? resourceRecord.path : []);

  if (!resourcePath.length) {
    return normalizedRid;
  }

  return resourcePath
    .map(function (pathRecord) {
      if (!pathRecord) return '';
      return pathRecord.name === 'root'
        ? 'Home'
        : (pathRecord.name || pathRecord['@class'] || '');
    })
    .filter(Boolean)
    .join(' / ');
}

function openAuxiliaryPointEditor(pointConfig, variableEdge) {
  if (variableEdge && !variableEdge.name && pointConfig && pointConfig.name) {
    variableEdge.name = pointConfig.name;
  }
  if (variableEdge && variableEdge.index == null && pointConfig && pointConfig.index != null) {
    variableEdge.index = pointConfig.index;
  }
  if (
    auxiliaryPointForm.tree &&
    auxiliaryPointForm.tree.vm &&
    variableEdge &&
    variableEdge.in &&
    typeof variableEdge.in === 'object' &&
    variableEdge.in['@rid']
  ) {
    auxiliaryPointForm.tree.vm.selectNode('/api/v1/point/' + variableEdge.in['@rid'].slice(1));
  }
  auxiliaryPointForm.editDialogue.call(auxiliaryPointForm, variableEdge);
}

function renderPointRow(ctrl, record, pointConfig, variableEdge) {
  var pointRid = getVariablePointRid(variableEdge);
  return m('div.mv2.pa3.ba.b--near-black.br2', [
    m('div.flex.flex-wrap.items-center.justify-between', [
      m('div.mr3', [
        m('div.f5.white', pointConfig.label || pointConfig.name || 'Report Point'),
        m('div.f6.moon-gray.mt1', buildResourcePathLabel(ctrl, pointRid))
      ]),
      m('div.flex.flex-wrap', [
        m(button, {
          label: 'Change Point',
          class: 'w5 mb2 mr3',
          func: function () {
            openAuxiliaryPointEditor(pointConfig, variableEdge);
          }
        }),
        m(button, {
          label: 'Remove Point',
          class: 'w5 mb2 mr3',
          func: function () {
            auxiliaryPointForm.deleteDialogue.call(auxiliaryPointForm, variableEdge);
          }
        })
      ])
    ])
  ]);
}

function renderSinglePoint(ctrl, record, pointConfig, variableEdges) {
  var variableEdge = variableEdges[0];
  if (!variableEdge) {
    return m(button, {
      label: 'Add Point',
      class: 'w5 mb2',
      func: function () {
        openAuxiliaryPointEditor(pointConfig, buildNewVariableEdge(record, pointConfig));
      }
    });
  }

  return renderPointRow(ctrl, record, pointConfig, variableEdge);
}

function renderMultiplePoints(ctrl, record, pointConfig, variableEdges) {
  return m('div', [
    variableEdges.map(function (variableEdge) {
      return renderPointRow(ctrl, record, pointConfig, variableEdge);
    }),
    m(button, {
      label: variableEdges.length ? 'Add Another Point' : 'Add Point',
      class: 'w5 mb2',
      func: function () {
        openAuxiliaryPointEditor(pointConfig, buildNewVariableEdge(record, pointConfig));
      }
    })
  ]);
}

component.view = function reportAuxiliaryPointsBuildView(vnode) {
  var ctrl = this;
  var record = vnode.attrs.record();
  var config = getAuxiliaryPointsConfig(record);
  var pointConfigs = Array.isArray(config && config.points) ? config.points : [];

  if (!config || config.enabled !== true || !pointConfigs.length) {
    return null;
  }

  return m('div.mh3.mb3', [
    m(heading, {label: config.heading || 'Report Points', class: 'f2 mb2 pv2'}),
    pointConfigs.map(function (pointConfig, idx) {
      var variableEdges = getMatchingVariableEdges(record, pointConfig);
      return m('div.mb3', [
        m('div.f4.mb2', pointConfig.label || pointConfig.name || 'Report Point'),
        pointConfig.multiple === true
          ? renderMultiplePoints(ctrl, record, pointConfig, variableEdges)
          : renderSinglePoint(ctrl, record, pointConfig, variableEdges)
      ]);
    })
  ]);
};

component.__testables = {
  buildNewVariableEdge: buildNewVariableEdge,
  getAuxiliaryPointsConfig: getAuxiliaryPointsConfig,
  getMatchingVariableEdges: getMatchingVariableEdges,
  normalizeVariableEdge: normalizeVariableEdge
};

module.exports = component;
